import script from "./realName.vue?vue&type=script&lang=ts&setup=true"
export * from "./realName.vue?vue&type=script&lang=ts&setup=true"

import "./realName.vue?vue&type=style&index=0&id=0635e4dd&lang=stylus&scoped=true"

import exportComponent from "D:\\project\\web\\vysa_wifi_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0635e4dd"]])

export default __exports__